import { Status } from "../assignments/assignment";
import { AdvancedSearchBodyParams } from "../users/users";

export interface PortalAssignmentRuleQueryParams {
  limit?: number;
  offset?: number;
  orderBy?: string;
  sort?: string;
  search?: string;
}

export interface GetPortalAssignmentRulesResult {
  count: number;
  previousPage: string;
  nextPage: string;
  rows: GetPortalAssignmentRuleResult[];
}

export interface GetPortalAssignmentRuleResult {
  ruleUid: string;
  name: string;
  priority: number;
  portalGroupUid?: string | null;
  portalGroupName?: string | null;
  deadlineNewStarter?: number | null;
  deadlineExistingUser?: number | null;
  filtersText: string;
  createdAt: string;
  affectedUsersCount?: number;
}

export interface PortalAssignmentRuleReorderBodyParams {
  ruleUid: string;
  priorityCurrent: number;
  priorityNew: number;
}

export interface GetPortalAssignmentRuleResult {
  ruleUid: string;
  name: string;
  priority: number;
  portalGroupUid?: string | null;
  portalGroupName?: string | null;
  deadlineNewStarter?: number | null;
  deadlineExistingUser?: number | null;
  filtersText: string;
  affectedUsersCount?: number;
}

export interface GetPortalAssignmentRuleDetailResult extends GetPortalAssignmentRuleResult {
  filters: AdvancedSearchBodyParams;
  finResult: UserSearchRow[];
}

export interface UserSearchRow {
  UserUid?: string;
  UserPortalUid: string;
  firstName: string;
  lastName: string;
  email: string;
  status: Status;
  filterImpact?: filterImpactEnum;
}

export enum filterImpactEnum {
  ADDED = "Added",
  REMOVED = "Removed",
  UNCHANGED = "Unchanged",
  ASSIGNED_BY_OTHER_RULE = "AssignedByOtherRule",
}

export interface PortalAssignmentRuleBodyParams {
  ruleUid?: string;
  name: string;
  portalGroupUid?: string | null;
  deadlineNewStarter?: number | null;
  deadlineExistingUser?: number | null;
  filters: AdvancedSearchBodyParams;
}

export interface PortalAssignmentRuleCreateUpdateResult {
  ruleUid: string;
}

export interface PortalAssignmentRuleBulkDeleteBodyParams {
  ruleUids: string[];
}
